import React from 'react';

function ViewMoodBoardTemplate ({ helpers }) {

	const { moodBoardLabel } = helpers;

	return (
		<>
			<button
				type="button"
				className="viewMoodBoard anchorLink"
				aria-label="view cart on mood board"
			>
				{moodBoardLabel}
			</button>

			<div className="helpFields lpTooltip">
				<p>You can add up to 9 designs to a mood board. It's a fun way to view and visually compare them.</p>
				<p>
					Individual items can also be added from product pages using our &ldquo;View In Your Room&rdquo;
					feature.
				</p>
			</div>
		</>
	);

}

export default ViewMoodBoardTemplate;
